"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Workbook {
    constructor(_workbookImpl) {
        this._workbookImpl = _workbookImpl;
    }
    getAllDataSourcesAsync() {
        return this._workbookImpl.getAllDataSourcesAsync();
    }
}
exports.Workbook = Workbook;
//# sourceMappingURL=Workbook.js.map